import p1 from "../../assets/images/p-1.png";
import * as Yup from "yup";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router";
import { Formik, Form, FormikContext } from "formik";
import { useParams } from "react-router-dom";
import { ReactMultiSelect, TextInput, FileInput, TextArea, NumberInput, } from "../../components/utilityComponent/form-fields";
import { toast } from "react-toastify"
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ckConfig from "../../config/ck-config";

const templateSchema = Yup.object({
    title: Yup.string()
        .trim()
        .min(2, "Minimum of two keywords required")
        .max(50, "Maximum of 50 keywords allowed")
        .required("Page name is required"),
    templateContent: Yup.string().trim().required("Description is required")

});


const NewEmailTemplateForm = () => {

    const history = useHistory();
    const [template, setTemplate] = useState();
    const { templateId } = useParams();
    const [initialValues, setInitialValues] = useState({
        title: "",
        templateContent: ""
    });
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false)
    const [color, setColor] = useState("#ffffff");
    const [valuesLoaded, setValuesLoaded] = useState(false);

    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    useEffect(() => {
        // let product = useSelector((state) => { return state.productDetails.listing; })

        if (templateId)
            fetchTemplate(templateId)
    }, [])

    useEffect(() => {
        if (template) {
            console.log("template set!!!")
            let data = { ...template }
            delete data._id
            setInitialValues({ ...template }); // 
            console.log("template title: ", template.title);
        }
    }, [template])

    useEffect(() => {
        if (!valuesLoaded && templateId && template)
            setValuesLoaded(true)
        else if (!templateId)
            setValuesLoaded(true);
    }, [initialValues])

    /** State */
    const fetchTemplate = async (id) => {
        const response = await axios.request({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            method: 'get',
            url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-email-template-by-id?id=${id}`
        });
        setTemplate(response.data);
    }


    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setInitialValues({ ...initialValues, [name]: value });
    };

    const onSubmit = async (values) => {
        setLoading(true);
        setDisable(true);
        if (templateId) {
            const callback = async () => {
                setLoading(false);
                setDisable(false);
                toast.success("Template successfully updated!");
                history.push("/cms-email-templates");
            };
            const response = await axios.request({
                data: { id: templateId, title: values.title, templateContent: values.templateContent },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                },
                method: 'put',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/edit-email-template`
            })
            callback()
            console.log("response for editing template: ", response.data);

        } else {
            const callback = async () => {
                setLoading(false);
                setDisable(false);
                toast.success("Template successfully saved!");
                history.push("/cms-email-templates");
            };
            const response = await axios.request({
                data: { title: values.title, templateContent: values.templateContent },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                },
                method: 'post',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/add-email-template`
            })
            callback()
            console.log("response for adding template: ", response.data);
        }
    };

    const handleOnEditorChange = (event, editor) => {
        const data = editor.getData();
        if (valuesLoaded)
            setInitialValues({ ...initialValues, templateContent: data })
        // console.log({ event, editor, data });
    }

    return (

        <>
            <div className="dashContentHeader px-5 mb-3 row">
                <h5 className="dashHeading mb-0 fontfammedium p-0">
                    {templateId ? "Edit Page" : "Add New Page"}
                </h5>

            </div>
            <div className="row dashboardCardRow px-5">
                <div className="col-lg-8 bg-white mt-5 shadow">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={templateSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {({ errors, values }) => (
                            console.log("Errors : ", errors),
                            (
                                <Form className="mg-login new-product mt-4 px-3">
                                    <div className="row mb-0">
                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Template Title"
                                                name="title"
                                                id="title"
                                                type="text"
                                                placeholder="Enter template title here"
                                                className="form-control "
                                                onChange={handleOnChange}
                                                isRequired
                                                errors={errors}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <hr className="w-100 mb-4" />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <label htmlFor="templateEditor">Email Template Content</label>
                                            <CKEditor
                                                id="templateEditor"
                                                editor={ClassicEditor}
                                                config={ckConfig.config}
                                                name="templateEditor"
                                                data={initialValues.templateContent}
                                                onReady={editor => {
                                                    // You can store the "editor" and use when it is needed.
                                                    console.log('Editor is ready to use!', editor);
                                                }}
                                                onChange={handleOnEditorChange}
                                                onBlur={(event, editor) => {
                                                    // console.log('Blur.', editor);
                                                }}
                                                onFocus={(event, editor) => {
                                                    // console.log('Focus.', editor);
                                                }}
                                            />
                                            <div className="invalid-feedback-ckEditor">
                                                {errors["templateContent"]}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between mb-5">
                                        <button className="mb-5 sub-button mt-4 px-4" onClick={() => history.push("/cms-email-templates")}>Back</button>
                                        <button
                                            type="submit"
                                            disabled={disable}
                                            className="mb-5 sub-button mt-4 px-4"
                                        >
                                            {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                                            {!loading && (templateId ? "Update" : "Submit")}
                                        </button>
                                    </div>
                                </Form>
                            )
                        )}
                    </Formik>
                    <form className="mg-login new-product mt-4 px-3"></form>
                </div>
            </div>
        </>
    );
}

export default NewEmailTemplateForm;